
const auth = {
  // Authentication
  auth: {
    login: "Login",
    register: "Register",
    logout: "Logout",
    loginDesc: "Enter your credentials to access your account",
    registerDesc: "Create a new account to get started",
    recovery: "Password Recovery",
    recoveryDesc: "Enter your email to receive a password reset link"
  }
};

export default auth;
